export default __webpack_public_path__ + "static/media/ailogo.a82793ba.png";